import { render, staticRenderFns } from "./farm_order_list.vue?vue&type=template&id=b3698bd4&scoped=true"
import script from "./farm_order_list.vue?vue&type=script&lang=js"
export * from "./farm_order_list.vue?vue&type=script&lang=js"
import style0 from "./farm_order_list.vue?vue&type=style&index=0&id=b3698bd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3698bd4",
  null
  
)

export default component.exports